var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildrenGround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62871 21.5V18.7701M3.62871 6.83959H2.5L7.48515 2.5L12.75 6.83959H11.3416M3.62871 6.83959V12.906M3.62871 6.83959H11.3416M11.3416 6.83959V9.87278M11.3416 21.5V12.906M3.62871 12.906H7.48515M3.62871 12.906V16.0403M11.3416 12.906H7.48515M11.3416 12.906V9.87278M11.3416 12.906H16.4208M7.48515 12.906V16.0403M7.48515 21.5V18.7701M3.62871 16.0403H7.48515M3.62871 16.0403V18.7701M7.48515 16.0403V18.7701M3.62871 18.7701H7.48515M21.5 12.906C21.5 10.3985 19.8696 9.83907 19.0545 9.87278H11.3416M21.5 12.906V21.5M21.5 12.906H16.4208M16.4208 12.906V16.5458M16.4208 16.5458C15.5743 16.5458 15 16.9941 15 17.9041C15 18.814 15.6683 19.1892 16.4208 19.1892C17.1733 19.1892 17.75 18.7143 17.75 17.9054C17.75 17.0966 17.2673 16.5458 16.4208 16.5458Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildrenGround);
export default __webpack_public_path__ + "static/media/children_ground.bd79c03717209cac8d0864714ac77da3.svg";
export { ForwardRef as ReactComponent };